import React, { Suspense, lazy } from 'react';
import useUserStore from 'store/useUserStore';
import { usePermissions } from 'access/usePermission';

const BagelChatRoot = lazy(() => import('./BagelChatRoot'));

/**
 * Permission-gated host that keeps Bagel chat (and @assistant-ui) out of the
 * initial main bundle until a logged-in user with `bagel:chat` needs it.
 */
export default function LazyBagelChatHost() {
  const user = useUserStore(s => s.user);
  const { can } = usePermissions();

  if (!user || !can('bagel:chat')) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <BagelChatRoot />
    </Suspense>
  );
}
